import React, { useEffect, useState, useRef, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import Alert from "@mui/material/Alert";
import {
     factTableEditTableRecordRequest,
     factTableGetTableRecordRequest,
} from "../../../../_redux/_actions";
import { contextApiActions } from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";

export default function EditRecordDataModal(props) {
     const [state, dispatch] = useContext(Context);

     const stringRef = useRef("");

     const actionDispatch = useDispatch();

     useEffect(() => {
          actionDispatch(factTableGetTableRecordRequest({ id: props.id }));
     }, []);

     const { manageList } = useSelector((state) => {
          return {
               manageList: state.factTable.dataRowDetails,
          };
     });

     const editDataRecord = () => {
          actionDispatch(
               factTableEditTableRecordRequest({
                    id: props.id,
                    jsonObjectString:
                         stringRef.current != ""
                              ? stringRef.current
                              : JSON.stringify(manageList),
                    closeModal: handleCloseEditRecord,
                    getManageDataList: props.getManageDataList,
               }),
          );
     };

     const handleCloseEditRecord = () => {
          dispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: false,
               },
          });
     };

     return (
          <>
               <div className="sba-add-record-data-wr">
                    <div className="sba-upload-json-view">
                         <JsonView
                              src={manageList}
                              editable={{
                                   delete: false,
                                   edit: true,
                              }}
                              onEdit={(params) => {
                                   stringRef.current = JSON.stringify(
                                        params.src,
                                   );
                              }}
                         />

                         {/* <Alert severity="error" sx={{ mt: 1 }}>
                              Date error Alert.
                         </Alert> */}
                    </div>
                    <div className="sba-add-record-data-wr__save">
                         <UiButton
                              onClick={editDataRecord}
                              name="Save"
                              variant="contained"
                         />
                    </div>
               </div>
          </>
     );
}
